import type { FaireProductEntity } from "../../entity_types/product";

export const p_b6sq9k6n8t: FaireProductEntity = {
  token: "p_b6sq9k6n8t",
  type: "product",
  name: "The Matcha - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/2ad119d05387c91cd1abd3445634626f60512d8984fdefae7a879e26a4c304ae.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/994dc93be380e4ef66264ab48f4f0a831812b2faac91ff187a19a42bc386863c.jpeg",
    "https://cdn.faire.com/fastly/979f820f58174fae741766609bfbee9de3231b4b98863d9830d21d57944c8c7f.jpeg"
  ],
  priceDollars: 206,
  description: "PREMIUM CEREMONIAL GRADE MATCHA\n\nCalling all matcha club members! Whisk up your daily dose of bliss with this exclusive, first harvest matcha from the lush valleys of Shizuoka, Japan. It's a vibrant emerald dream with a super smooth mouthfeel and creamy umami finish. Moderately caffeinated to keep you feeling energized and balanced.\n\nPREMIUM CEREMONIAL GRADE - SPRING HARVEST - RAW \n\nHow to Enjoy:\n\n * Whisk 1/2 to 1 tsp matcha powder with 1 tbsp hot (not boiling) water in a zig-zag motion until tiny bubbles form. Top with 1 cup of hot or cold milk for a matcha latte. Sweeten to taste if desired.\n * Add to smoothies and baked goods! \n\nWhen to Enjoy:\n\n * As a substitute for your morning coffee \n * As a smooth, mid-day pick-me-up \n * When you need to boost your mood \n\nModerate caffeine levels\n",
  tags: [],
  msrpDollars: 412,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:37.003Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
